class ExtraInformation {
  text: string;
  img: string;
  link: string | null;

  constructor(text: string, img: string, link: string | null = null) {
    this.text = text;
    this.img = img;
    this.link = link;
  }
}

const extract = new ExtraInformation(
  'Получите выписку из домовой книги,\nединый жилищный документ\nили справку о наличии/отсутствии\nзадолженности/переплаты',
  'extract',
  'https://www.mos.ru/pgu/ru/application/guis/77240201/#step_1'
);
const finder = new ExtraInformation(
  'Отсканируйте QR код\nлибо введите идентификатор\nиз полученного \n(или сформированного) документа',
  'finder'
);
const proof = new ExtraInformation(
  'Нажмите кнопку "Проверить"\nи ознакомьтесь с результатом',
  'proof'
);

const EXTRA_BLOCKS = [extract, finder, proof];

export { EXTRA_BLOCKS };
